import merge from 'lodash/merge';
import OfficialDeskService from './services/search.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
import AppFilter from './views/AppFilter.svelte';
import AppList from './views/AppList.svelte';
class OfficialDeskApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const searchService = new OfficialDeskService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new AppFilter({
            target: this.targetFilterElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
        new AppList({
            target: this.targetListElement,
            props: {
                serviceProvider: this.serviceProvider,
            }
        });
    }
    get targetListElement() {
        const { listEl } = this.options;
        const element = document.querySelector(listEl);
        if (null === element) {
            throw new Error("The container for displaying list does not exist");
        }
        return element;
    }
    get targetFilterElement() {
        const { filterEl } = this.options;
        const element = document.querySelector(filterEl);
        if (null === element) {
            throw new Error("The container for displaying filter does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            listEl: null,
            filterEl: null,
            placeholder: null,
            cta: null,
            reset: null,
            structureKeys: null,
            groupId: null,
            showSiteUrl: null,
            fields: null,
        }, this.options);
    }
}
const filter = document.getElementById('filter-official-desk-module');
const list = document.getElementById('list-official-desk-module');
if (list && filter) {
    const structureKeys = filter.getAttribute("data-structure-keys") || "";
    const groupId = filter.getAttribute('data-group-id') || "";
    const showSiteUrl = filter.getAttribute("data-show-site-url") || "false";
    const cta = filter.getAttribute("data-cta") || "Filtrovat";
    const reset = filter.getAttribute("data-ctaReset") || "Vymazat filtr";
    const placeholder = filter.getAttribute("data-placeholder") || "Vyhledat...";
    const fields = filter.getAttribute("data-fields") || "";
    const officialDeskApp = new OfficialDeskApp({
        filterEl: '#filter-official-desk-module',
        listEl: "#list-official-desk-module",
        structureKeys,
        groupId,
        showSiteUrl: showSiteUrl === 'true',
        cta,
        reset,
        placeholder,
        fields,
    });
    officialDeskApp.mount();
}
